import React from 'react';

const RestartBtn = (props) => (
    <div 
    	className="restart-btn"
    	onClick={props.onClick}
    ></div>
);

export default RestartBtn;


// WEBPACK FOOTER //
// ./src/components/sections/shared/RestartBtn.js